// Resume Privacy Level *****************************************************************************
// pathname: /v1/resume/privacy-level
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi';
import { ApiResumePrivacyLevelOk } from 'src/types/v1-api-types';

interface SwrResumePrivacyLevelProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

export const useSwrResumePrivacyLevel = (props: SwrResumePrivacyLevelProps) => {
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiResumePrivacyLevelOk>({
    url: '/v1/resume/privacy-level',
    shouldFetch,
    locale,
    apiOptions: {
      dedupingInterval: 60 * 1000,
      revalidateOnFocus: false,
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
